const radii = {
  pill: "9999px",
  circular: "50%",
  badge: "4px",
  box: "8px",
  card: "10px",
  box2x: "16px",
  button: "4px",
};

export default radii;
